import styled from 'styled-components'

export const Container = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  max-height: 82vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  font-family: 'Inter', sans-serif;
`

export const GradientHeader = styled.div`
  background: linear-gradient(135deg, #0090d3 0%, #00a8e8 100%);
  border-radius: 12px 12px 0 0;
  padding: 20px 20px 48px;
  position: relative;
`

export const HeaderTop = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const CloseButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`

export const AvatarWrap = styled.div`
  position: absolute;
  bottom: -36px;
  left: 24px;
`

export const Avatar = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: white;
  border: 3px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 700;
  color: #0090d3;
  letter-spacing: -1px;
`

export const Body = styled.div`
  padding: 48px 24px 24px;
`

export const NameRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
`

export const Name = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #262626;
`

export const Email = styled.div`
  font-size: 13px;
  color: #8c8c8c;
  margin-bottom: 14px;
`

export const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 20px;
  background: #eef7fc;
  color: #0090d3;
  border: 1px solid #b3dcf0;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: #d9eef9;
  }
`

export const BadgesRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 20px;
`

export const StatusBadge = styled.span<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ $active }) => ($active ? '#f6ffed' : '#fff1f0')};
  color: ${({ $active }) => ($active ? '#389e0d' : '#cf1322')};
`

export const ProfileBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: #eef2ff;
  color: #3730a3;
`

export const Divider = styled.div`
  height: 1px;
  background: #f0f0f0;
  margin: 16px 0;
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 20px;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const InfoLabel = styled.span`
  font-size: 11px;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const InfoValue = styled.span`
  font-size: 14px;
  color: #262626;
  font-weight: 600;
`

export const SkillsBox = styled.div`
  background: #f0f7ff;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
`

export const SkillsBoxLabel = styled.div`
  font-size: 11px;
  color: #0090d3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 10px;
`

export const ChipsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`

export const Chip = styled.span`
  padding: 4px 12px;
  border-radius: 20px;
  background: white;
  color: #1a56db;
  border: 1px solid #b3ccf5;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(26, 86, 219, 0.08);
`

export const EmptySkills = styled.span`
  font-size: 13px;
  color: #8c8c8c;
`

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #595959;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
`

export const AttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
`

export const AttachmentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 6px;
  font-size: 13px;
  color: #262626;
`

export const AttachmentIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #eef7fc;
  color: #0090d3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
`

export const AttachmentName = styled.span`
  flex: 1;
  word-break: break-word;
`

export const AttachmentLink = styled.a`
  color: #0090d3;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  flex-shrink: 0;

  &:hover {
    text-decoration: underline;
  }
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
`

export const CloseTextButton = styled.button`
  padding: 10px 20px;
  border-radius: 20px;
  background: transparent;
  color: #595959;
  border: 1px solid #d9d9d9;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
  }
`
